if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      const cartTotal = Number(this.getAttribute('data-cart-total-amount')) || 0;
      const threshold = Number(this.getAttribute('data-free-shipping')) || 0;
      const eligible = this.hasAttribute('data-eligible');
      const remainingFormatted = this.getAttribute('data-remaining-formatted');

      let progress = Number(this.getAttribute('data-progress'));
      if (Number.isNaN(progress)) {
        progress = threshold > 0 ? Math.min(100, Math.max(0, (cartTotal / threshold) * 100)) : 100;
      } else {
        progress = Math.min(100, Math.max(0, progress));
      }

      let shippingMessage = '';
      let shippingSuccess = eligible || (threshold > 0 && cartTotal >= threshold);

      if (shippingSuccess) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
      } else if (remainingFormatted) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
          '{{ remaining_amount }}',
          remainingFormatted
        );
      } else {
        const remaining = Math.max(0, threshold - cartTotal);
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
          '{{ remaining_amount }}',
          this._formatMoney(remaining, KROWN.settings.shop_money_format)
        );
      }

      this.classList.toggle('is-complete', shippingSuccess);
      this.innerHTML = `
        <div class="shipping-notice__content">
          <p class="shipping-notice__message">${shippingMessage}</p>
          <div class="shipping-notice__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}" aria-label="${shippingMessage.replace(/"/g, '&quot;')}">
            <span class="shipping-notice__bar" style="width: ${progress}%;"></span>
          </div>
        </div>
      `;
    }

    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
